import { Button, Select } from 'antd';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import ArrowIcon from '../../assets/images/catalogue/arrowIcon';
import EditIcon from '../../assets/images/catalogue/EditIcon';
import { ICategoryList } from '../../types/category';
import { v4 as uuid } from 'uuid';
import FloatButtons from '../../components/floatButtons';

interface ITypeProduct {
  id: number;
  type: string;
}

interface ITypeProductList {
  list?: ICategoryList;
  handleChangeType: (option: ITypeProduct) => void;
  value: ITypeProduct;
  loading?: boolean;
}

const ChooseType: FC<ITypeProductList> = ({ list, handleChangeType, value, loading }: ITypeProductList) => {
  const { goBack } = useHistory();
  const { Option } = Select;
  const changeType = (option: string) => {
    const optionFormat = JSON.parse(option);
    if (optionFormat?.id && optionFormat?.name) {
      handleChangeType({ id: optionFormat.id, type: optionFormat.name });
    }
  };

  return (
    <div id="selectType">
      <div className="backHeader">
        <div
          className="backIcon"
          onClick={() => {
            goBack();
          }}
        >
          <ArrowIcon fill="#070F21" />
        </div>
      </div>
      <div className="containerSelect">
        <div className="customSelectContainer">
          {loading ? (
            <div className="inputSkeleton" />
          ) : (
            <Select
              onChange={e => {
                if (e) {
                  changeType(e);
                }
              }}
              className="categorySelect"
              placeholder="Categoria"
              suffixIcon={<ArrowIcon className="rotateIcon" />}
            >
              {list &&
                list.map(item => {
                  if (item.id !== 2) {
                    return (
                      <Option key={uuid()} value={JSON.stringify(item)}>
                        {item.name}
                      </Option>
                    );
                  }
                  return null;
                })}
            </Select>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChooseType;
